import { FC, JSX } from 'react';

import { ContentStyles } from '@/entities/content/api/types';

interface IOptionProps {
  data: ContentStyles;
}

const Option: FC<IOptionProps> = ({
  data: {
    name,
    config: { button_settings, colors_settings },
  },
}): JSX.Element => (
  <div className="flex gap-1 py-1">
    <div className="flex">
      <div
        className="z-50 h-4 w-4 rounded-full"
        style={{ backgroundColor: button_settings?.link_button?.bg_color }}
      />
      <div
        className="z-40 -ms-1 h-4 w-4 rounded-full"
        style={{ backgroundColor: colors_settings?.primary_color }}
      />
      <div
        className="z-30 -ms-1 h-4 w-4 rounded-full border"
        style={{
          backgroundColor: colors_settings?.icon_color,
          borderColor:
            colors_settings?.icon_color?.toLocaleLowerCase() === '#ffffff'
              ? 'black'
              : colors_settings?.icon_color,
        }}
      />
    </div>
    <div className="text-base font-light leading-4">{name}</div>
  </div>
);

export default Option;
